import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Download, X } from 'lucide-react';
import { isAndroid, isStandalone } from '@/lib/platform';
import { useInstallPrompt } from '@/lib/pwaInstall';

// Top bar for Android visitors: installs the web app (PWA) to the home screen automatically
// via the shared beforeinstallprompt event.
export function InstallBanner() {
  const [dismissed, setDismissed] = useState(false);
  const { canInstall, promptInstall } = useInstallPrompt();

  if (dismissed || isStandalone() || !isAndroid() || !canInstall) return null;

  return (
    <div data-testid="android-install-banner" className="bg-obsidian text-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-2.5 flex items-center justify-between gap-3">
        <p className="text-sm font-medium">Install The Tiffin app on your phone</p>
        <div className="flex items-center gap-2 shrink-0">
          <Button
            data-testid="android-install-btn"
            onClick={promptInstall}
            className="h-9 rounded-full px-4 bg-saffron hover:bg-saffron-hover text-white text-sm font-semibold gap-1.5"
          >
            <Download size={15} /> Install app
          </Button>
          <button
            data-testid="android-install-dismiss"
            onClick={() => setDismissed(true)}
            aria-label="Dismiss"
            className="h-9 w-9 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
